<form class="form" #communicationForm="ngForm" (ngSubmit)="onSubmit()">
  <div class="row">
    <div class="col-md-6">
      <mat-checkbox
        [(ngModel)]="communication.communication_channel.email"
        class="example-margin"
        [checked]="EmailComplete"
        [ngModelOptions]="{ standalone: true }"
      >
        Email
      </mat-checkbox>
      <span class="ml-20"></span>
      <mat-checkbox
        [(ngModel)]="communication.communication_channel.sms"
        class="example-margin"
        [checked]="SMSComplete"
        [ngModelOptions]="{ standalone: true }"
      >
        SMS
      </mat-checkbox>
      <span class="ml-20"></span>
      <!-- <mat-checkbox
        [(ngModel)]="communication.communication_channel.phone"
        class="example-margin"
        [checked]="PhoneComplete"
        [ngModelOptions]="{ standalone: true }"
      >
        Phone
      </mat-checkbox> -->
    </div>
  </div>
  <div style="text-align: center">
    <button
      type="submit"
      mat-raised-button
      class="btn btn-primary"
      color="primary"
    >
      Save
    </button>
    &nbsp;&nbsp;&nbsp;
    <a
      (click)="cancelClick()"
      mat-raised-button
      class="btn btn-light-primary btn-bold"
    >
      Cancel
    </a>
  </div>
</form>
